import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=abbc8f04&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbc8f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abbc8f04')) {
      api.createRecord('abbc8f04', component.options)
    } else {
      api.reload('abbc8f04', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=abbc8f04&scoped=true&", function () {
      api.rerender('abbc8f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/onePageAdv2/Index.vue"
export default component.exports